export default __webpack_public_path__ + "static/media/nodejs-alone.615ffbea.svg";